import {
  getCurrentOrganizationIdFromLocalStorage,
  getRedirectPathFromLocalStorage,
  Loading,
} from '@salescore/client-common'
import { logger } from '@salescore/frontend-common'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

const Page = () => {
  const organizationId = getCurrentOrganizationIdFromLocalStorage()
  const { provider } = Route.useParams()

  useEffect(() => {
    const parameters = new URLSearchParams(globalThis.location.search)
    const code = parameters.get('code')
    const state = parameters.get('state')

    const getPath = () => {
      const parameterString = `oauthCode=${code ?? ''}&state=${state ?? ''}&provider=${provider}`
      const pathFromLocalStorage = getRedirectPathFromLocalStorage()
      if (pathFromLocalStorage !== null && pathFromLocalStorage !== '') {
        return `${pathFromLocalStorage}?${parameterString}`
      }
      if (organizationId !== null && organizationId !== '') {
        const pathSub = `/o/${organizationId}/settings/sources`
        return `${pathSub}?${parameterString}`
      }

      logger.debug(`[callback] path nor organizationId not found`, parameterString)
      return `/?${parameterString}`
    }
    const path = getPath()
    // redirectだとなぜかAuth0の認証エラーになるため、redirectを使わない
    // redirect(path)
    logger.debug(`[callback] path found`, path, parameters)
    location.assign(path)
  }, [organizationId, provider]) // 初期レンダリング時にrouter.queryには値が入っていないことがある？

  return <Loading message={`認証中...`} />
}

export const Route = createFileRoute('/auth/$provider/callback')({
  component: Page,
})
